import React, { useState } from "react";
import ImageGrid from "./ImageGrid";
import ProgressBar from "./ProgressBar";
import Modal from "./Modal";
import "../../css/Shop.css";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";

const Shop = () => {
  const [selectedImg, setSelectedImg] = useState(null);
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [text, setText] = useState("");

  const types = ["image/png", "image/jpeg", "image,jpg"];

  const [user] = useAuthState(auth);

  function TexthandleChange(e) {
    setText(e.target.value);
  }

  const changeHandler = (e) => {
    let selected = e.target.files[0];

    if (selected && types.includes(selected.type)) {
      setFile(selected);
      setError("");
    } else {
      setFile(null);
      setError("Please select an image file (jpeg or png)");
    }
  };

  if (user) {
    return (
      <form>
        <input
          className="info-image"
          type="text"
          placeholder="description"
          value={text}
          onChange={TexthandleChange}
          onClick={() => setText("")}
        />

        <label>
          <input type="file" onChange={changeHandler} />

          <span>+</span>
        </label>
        <div className="output">
          {error && <div className="error"> {error}</div>}
          {file && <div> {file.name}</div>}
          {file && (
            <ProgressBar file={file} setFile={setFile} imageText={text} />
          )}
          <ImageGrid setSelectedImg={setSelectedImg} />
          {selectedImg && (
            <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} />
          )}
        </div>
      </form>
    );
  } else {
    return (
      <div className="output">
        {error && <div className="error"> {error}</div>}
        {file && <div> {file.name}</div>}
        {file && <ProgressBar file={file} setFile={setFile} imageText={text} />}
        <ImageGrid setSelectedImg={setSelectedImg} />
        {selectedImg && (
          <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} />
        )}
      </div>
    );
  }
};

export default Shop;
